export {default as Padding} from './Padding'



// WEBPACK FOOTER //
// ./src/components/padding/index.js